/**
 * @generated SignedSource<<aa22753a42033184308f060126c44505>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type StoreStuffTypeEnum = "premium_non_refundable" | "premium_refundable" | "%future added value";
export type StoreStuffCreateInput = {
  description?: string | null;
  endAt?: any | null;
  period?: number | null;
  stuff?: string | null;
  title: string;
  type: StoreStuffTypeEnum;
};
export type StoreStuffCreateDialog_storeStuffCreateMutation$variables = {
  input: StoreStuffCreateInput;
};
export type StoreStuffCreateDialog_storeStuffCreateMutation$data = {
  readonly storeStuffCreate: {
    readonly id: string;
  };
};
export type StoreStuffCreateDialog_storeStuffCreateMutation = {
  response: StoreStuffCreateDialog_storeStuffCreateMutation$data;
  variables: StoreStuffCreateDialog_storeStuffCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "StoreStuff",
    "kind": "LinkedField",
    "name": "storeStuffCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StoreStuffCreateDialog_storeStuffCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StoreStuffCreateDialog_storeStuffCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8b98c91fa8140b8a78c4535ca377ae56",
    "id": null,
    "metadata": {},
    "name": "StoreStuffCreateDialog_storeStuffCreateMutation",
    "operationKind": "mutation",
    "text": "mutation StoreStuffCreateDialog_storeStuffCreateMutation(\n  $input: StoreStuffCreateInput!\n) {\n  storeStuffCreate(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "886b6edd304ac153db299a536cc63673";

export default node;
